module.exports = __webpack_public_path__ + "static/media/currBanner.26fddd96.jpg";